import { makeStyles } from '@material-ui/core/styles';
import { iconRadioOn, iconRadio } from 'assets/icons/importIcon'

const useStyles = makeStyles((theme: any) => {
  return {
    containerInputPrice: {
        display: 'flex',
        flexDirection: 'column',
    },
  };
});

export default useStyles;
